// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../styles/InfluencerBadge.style';

const InfluencerBadge = (props) => {
  const { text, className } = props;

  return (
    <Badge className={`${className} influencer-badge`} fontFamily="secondary">
      {text}
    </Badge>
  );
};

InfluencerBadge.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};

InfluencerBadge.defaultProps = {
  className: '',
};

export default InfluencerBadge;
